/**
 * F1. Экзамен: 5 вопросов по 4 варианта на одном экране; погашенные
 * «вспомнили: не то» варианты выключены (их число задают знания), сдача —
 * при ≥ 3 верных. Кнопка «Сдать» активна, когда отвечено на все.
 */
import { t } from '@life/i18n';
import { EXAM_PASS_CORRECT, type ExamInput, type ExamState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Exam({ state, onInput }: MinigameScreenProps<ExamInput, ExamState>) {
  const [answers, setAnswers] = useState<(number | null)[]>(() => state.questions.map(() => null));
  const complete = answers.every((a) => a !== null);

  return (
    <>
      <p class="hint">{t('ui.minigame.exam.rules', { pass: EXAM_PASS_CORRECT, total: state.questions.length, hidden: state.hiddenWrong })}</p>
      {state.questions.map((q, i) => (
        <div class="q" key={q.key} data-question={i}>
          <p class="q-text">
            <span class="mono note">{t('ui.minigame.exam.q', { n: i + 1 })}</span> {t(q.key)}
          </p>
          <Choice
            label={t(q.key)}
            items={q.options.map((key, j) => ({
              text: t(key),
              ...(q.hidden.includes(j) ? { disabled: true, note: t('ui.minigame.exam.hidden') } : {}),
            }))}
            value={answers[i] ?? null}
            onChange={(j) => setAnswers(answers.map((a, k) => (k === i ? j : a)))}
          />
        </div>
      ))}
      <button type="button" class="btn accent block" disabled={!complete} onClick={() => onInput({ answers: answers.map((a) => a ?? -1) })}>
        {t('ui.minigame.exam.submit')}
      </button>
    </>
  );
}
